module.exports = __webpack_public_path__ + "img/Dimerco-logo.2a7cb9df.svg";